import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { ResistanceDetail } from './pages/ResistanceDetail'
import { Privacy } from './pages/Privacy'
import { Layout } from './components/Layout'

function App() {
  const { user, loading } = useAuth()

  console.log('App render:', { user: !!user, email: user?.email, loading })

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading... ({Math.floor(Date.now() / 1000)})</p>
          <button 
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded"
            onClick={() => window.location.reload()}
          >
            Reload Page
          </button>
          <p className="mt-2 text-xs text-gray-500">If this keeps spinning, check browser console for errors</p>
        </div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/privacy" element={<Privacy />} />

        {user ? (
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="dashboard/resistance/:resistanceId" element={<ResistanceDetail />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        ) : (
          <>
            <Route path="/*" element={<Login />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  )
}

export default App